// One-shot, in-memory flag: "the user came back from the Tickets page, so the
// Need Help modal should open again".
//
// Kept in a plain module variable on purpose (not localStorage/sessionStorage):
// it survives route changes inside the app, nothing can clear it by accident,
// and it disappears on a real page reload, so a refresh never pops the modal.

let pending = false;

export const markNeedHelpReturn = () => {
  pending = true;
};

// Returns true once, then resets.
export const consumeNeedHelpReturn = () => {
  const value = pending;
  pending = false;
  return value;
};
